module.exports = __webpack_public_path__ + "media/packs/landing-page-90d9734726af42fd1ac65ef85e5c6fd4.svg";